<template>
  <VModal :showing="showing" container-classes="w-full max-w-md" @update:showing="onClose">
    <h2 class="text-xl mb-8 mr-8 truncate">Delete label(s)</h2>
    <p class="text-gray-800 font-light">This will affect all scenes for this model.</p>
    <p class="text-gray-800 font-light">Are you sure you want to continue?</p>
    <div class="flex flex-row gap-4 mt-12 w-full justify-end">
      <VButton class="w-42" data-testid="cancel-button" @click="onClose">Cancel</VButton>
      <VButton class="w-42" variant="danger" data-testid="delete-button" @click="onConfirm">Confirm</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'

const props = defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['confirm-delete', 'update:showing'])

onMounted(() => document.addEventListener('keypress', enterKeyListener))
onUnmounted(() => document.removeEventListener('keypress', enterKeyListener))

function onClose() {
  emit('confirm-delete', false)
}

function onConfirm() {
  emit('confirm-delete', true)
}

const enterKeyListener = (e: KeyboardEvent) => {
  if (e.key === 'Enter' && props.showing) {
    emit('confirm-delete', true)
  }
}
</script>
